import React, { useState, useEffect, useRef } from 'react';
import ContextToolBar from '../ContextToolBar/ContextToolBar';
import ImageUploader from '../ImageUploader/ImageUpoader';
import Canvas from './Canvas';

function CanvasContainer({
  svgContent, selectedTool, selectedColor,
  setSelectedColor, selectedNomexColor, setSelectedNomexColor,
  showContextToolBar, setShowContextToolBar, setSelectedTool,
  canvasState, setCanvasState, setEnvelopeDimension,
  defaultColor, defaultNomexColor, history, setHistory,
  redoStack, setRedoStack, canvasRef, viewMode,
  scenes, selectedScene, setSelectedScene, selectedFabric, paraventSize
}) {
  const [modifiedSvgContent, setModifiedSvgContent] = useState(null);
  const [svgDimensions, setSvgDimensions] = useState(null);
  const [showImageUploader, setShowImageUploader] = useState(false);
  const [highlightColor, setHighlightColor] = useState(null);
  const containerRef = useRef(null);

  const handleCloseModal = () => {
    setShowImageUploader(false);
  };

  useEffect(() => {
    if (!svgContent) return;

    const viewBoxValues = svgContent.properties.viewBox.split(' ');
    const width = parseFloat(viewBoxValues[2]);
    const height = parseFloat(viewBoxValues[3]);
    const halfWidth = width / 2;

    // Find all unique X coordinates and sort them
    const sortedX = Array.from(new Set(svgContent.children
      .map(child => parseFloat(child.properties?.x || 0))))
      .sort((a, b) => a - b);

    // Find the split point that is closest to halfWidth (preferring >= halfWidth)
    const splitX = sortedX.find(x => x >= halfWidth) || halfWidth;

    const newSvgContent = JSON.parse(JSON.stringify(svgContent));
    newSvgContent.children.forEach(child => {
      if (child.properties) {
        const currentX = parseFloat(child.properties.x || 0);
        child.properties.x = (currentX + (width - splitX)) % width;
      }
    });

    setSvgDimensions({ width, height });
    setModifiedSvgContent(newSvgContent);
  }, [svgContent]);

  const handleSetLoadlinesColor = (color) => {
    setCanvasState(prev => ({ ...prev, loadlines: color }));
  };

  return (
    <div ref={containerRef}
      style={{
        width: 'fit-content',
        display: viewMode === "Envelope" ? 'none' : 'flex',
        height: 'fit-content',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      {svgDimensions && selectedTool && canvasRef && showContextToolBar && ["Split", "Grid"].includes(viewMode) &&
        <ContextToolBar
          selectedTool={selectedTool}
          selectedColor={selectedColor}
          setSelectedColor={setSelectedColor}
          selectedNomexColor={selectedNomexColor}
          setSelectedNomexColor={setSelectedNomexColor}
          selectedFabric={selectedFabric}
          viewMode={viewMode}
          highlightColor={highlightColor}
          canvasRef={canvasRef}
          onClose={() => {
            setShowContextToolBar(false);
          }}
          showModal={showImageUploader}
          setShowModal={setShowImageUploader}
          nomexRows={canvasState?.nomexBottomRows || 1}
          loadlinesColor={canvasState?.loadlines}
          setLoadlinesColor={handleSetLoadlinesColor}
        />}
      {<ImageUploader
        show={showImageUploader}
        onHide={handleCloseModal}
        canvasRef={canvasRef}
        selectedTool={selectedTool}
        canvasState={canvasState}
      />}
      {svgDimensions && modifiedSvgContent &&
        <Canvas id="canvas-container"
          svgContent={modifiedSvgContent}
          svgDimensions={svgDimensions}
          selectedTool={selectedTool}
          setSelectedTool={setSelectedTool}
          selectedColor={selectedColor}
          selectedNomexColor={selectedNomexColor}
          canvasState={canvasState}
          setCanvasState={setCanvasState}
          setEnvelopeDimension={setEnvelopeDimension}
          defaultColor={defaultColor}
          defaultNomexColor={defaultNomexColor}
          history={history}
          setHistory={setHistory}
          redoStack={redoStack}
          setRedoStack={setRedoStack}
          containerRef={containerRef}
          viewMode={viewMode}
          paraventSize={paraventSize}
          setHighLightColor={setHighlightColor}
          ref={canvasRef}
          style={{ position: 'absolute', top: 0, left: 0, border: '1px solid black', paddingTop: '1px', paddingRight: '1px' }} />}
    </div>
  );
}

export default CanvasContainer;